export enum QueueOptions {
  WorkdaySupplierDomestic = 'WorkdaySupplierDomestic',
  WorkdaySupplierForeign = 'WorkdaySupplierForeign',
  BfitArchive = 'BfitArchive',
  DataWarehouse = 'DataWarehouse'
}